import axios from "./axios";
import { ADMIN_API_ROOT } from "./api-root";

export const GlobalPayServer = {
    PayChannel: {
        list: (params: any) => {
            return axios.get(`${ADMIN_API_ROOT}/pay-channel/list`, { params });
        },
        create: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/pay-channel/add`, params);
        },
        update: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/pay-channel/update`, params);
        },
        delete: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/pay-channel/delete`, params);
        },
    },
    PayCurrency: {
        list: (params: any) => {
            return axios.get(`${ADMIN_API_ROOT}/pay-currency/list`, { params });
        },
        selectList: (params?: any) => {
            return axios.get(`${ADMIN_API_ROOT}/pay-currency/select-list`, { params });
        },
        create: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/pay-currency/add`, params);
        },
        update: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/pay-currency/update`, params);
        },
        delete: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/pay-currency/delete`, params);
        },
    },
    PayConfig: {
        list: (params: any) => {
            return axios.get(`${ADMIN_API_ROOT}/pay-config/list`, { params });
        },
        create: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/pay-config/add`, params);
        },
        update: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/pay-config/update`, params);
        },
        delete: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/pay-config/delete`, params);
        },
    },
    PayOrder: {
        list: (params: any) => {
            return axios.get(`${ADMIN_API_ROOT}/consumption-pay/pay-order-list`, { params });
        },
        audit: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/consumption-pay/pay-order-audit`, params);
        },
    },
}
